export default {
  frontRoutes: [
    {
      path: '/index/rec-package',
      name: 'IndexRecommendPackage',
      component: () => import(/* webpackChunkName: "package" */ '../views/package/Package.vue'),
    },
    {
      path: '/package',
      name: 'Package',
      component: () => import(/* webpackChunkName: "package" */ '../views/package/Package.vue'),
    },
    {
      path: '/package/:id',
      name: 'PackageDetail',
      component: () =>
        import(/* webpackChunkName: "package" */ '../views/package/PackageDetail.vue'),
    },
  ],
};
